import { render, staticRenderFns } from "./news_banner_09m.vue?vue&type=template&id=3f3edbfe&scoped=true&"
import script from "./news_banner_09m.vue?vue&type=script&lang=js&"
export * from "./news_banner_09m.vue?vue&type=script&lang=js&"
import style0 from "./news_banner_09m.vue?vue&type=style&index=0&id=3f3edbfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3edbfe",
  null
  
)

/* custom blocks */
import block0 from "./news_banner_09m.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports